import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsDefect, PmsDefect } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsDefect>
    useData={usePmsDefect}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
